'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { useState } from 'react';
import { productImageDimensions } from './product-image-dimensions';

export const ProductMainImage = ({
  image,
  name,
}: {
  image: { url: string; name: string; metadata?: unknown };
  name: string;
}) => {
  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState<{ url: string; name: string }[]>([]);
  const dimensions = productImageDimensions(image);

  const handleOpenGallery = (images: any, index: number) => () => {
    if (Array.isArray(images) && index >= 0 && index < images.length) {
      const newImages = [...images.slice(index), ...images.slice(0, index)];
      setImagesSorted(newImages);
      setIsOpen(true);
    } else if (images && !Array.isArray(images)) {
      setImagesSorted([images]);
      setIsOpen(true);
    }
  };

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      <button
        type="button"
        className="block w-full text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
        onClick={handleOpenGallery(image, 0)}
      >
        <Image
          src={image.url}
          alt={resolveImageAlt(image, name)}
          height={dimensions?.height ?? 0}
          width={dimensions?.width ?? 0}
          quality={90}
          priority
          loading="eager"
          sizes="(max-width: 767px) 100vw, (max-width: 1535px) 55vw, 900px"
          className="h-auto w-full cursor-pointer object-cover object-center md:max-w-[900px]"
        />
      </button>
    </>
  );
};
